import React from 'react'
import '../styles/components/chooserBlock.css'
import AniLink from "gatsby-plugin-transition-link/AniLink"

const ChooserBlock = ({data}) => {
    const themeChooser = data.strapiThemeChooser
    return (
        <div className={'page-chooserblock d-flex position-absolute'} style={{top: 0}}>
            {
                themeChooser.Themes.map((chooser, index) => (
                    <AniLink cover direction={"left"} duration={1} bg="black" className={'container-link-chooserBlock'}
                             key={chooser.id} to={`/${chooser.slug}`} style={{textDecoration: "none"}}>
                        <section className={'d-flex flex-column chooser-container'} style={{
                            background: 'linear-gradient(135deg, red, red 60%, blue)',
                            backgroundImage: `url('${chooser.imageChooser.publicURL}')`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            backgroundSize: 'cover'
                        }}>
                            <div className={'chooser-container filter'}>
                                <div
                                    className={index === 0 ? 'first-block-image block-imagechooser' : 'secondary-block block-imagechooser'}
                                    id={chooser.id}>
                                    <div className={'container-fluid'}>
                                        <div className={'title-chooserblock'}>
                                            <span className={''}>{chooser.title}</span>
                                        </div>
                                        <div
                                            className={'d-flex align-items-center justify-content-center pt-2 img-container'}>
                                            <img src={chooser.imageChooser.publicURL} alt="Theme ilustration"
                                                 className={'image-chooserblock filter-image'}/>
                                        </div>
                                        <div className={'button-container'}>
                                            <button className={'button-chooserblock'}>
                                                {chooser.button}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </AniLink>
                ))
            }
        </div>
    )
}


export default ChooserBlock